import "./GridOffsetProperties.css"
import React from "react";
import {fileEditorStore} from "../../stores/FileEditorStore";
import {globalContext} from "../editor/GlobalContext";
import {observer} from "mobx-react-lite";
import InputTextProperty from "../properties/basic/InputTextProperty";
import PropsGroup from "../properties/basic/PropsGroup";

function GridOffsetProperties() {
    globalContext.editorContext().zeroOffsetX = fileEditorStore.zeroOffsetX
    globalContext.editorContext().zeroOffsetY = fileEditorStore.zeroOffsetY

    function setZeroOffsetX(zeroOffsetX: string) {
        if (!Number.isNaN(+zeroOffsetX)) {
            fileEditorStore.setZeroOffsetX(+zeroOffsetX)
        }
    }

    function setZeroOffsetY(zeroOffsetY: string) {
        if (!Number.isNaN(+zeroOffsetY)) {
            fileEditorStore.setZeroOffsetY(+zeroOffsetY)
        }
    }

    return <>
        <PropsGroup name={"Grid offset:"}>
            <InputTextProperty
                label={"x:"}
                val={fileEditorStore.zeroOffsetX}
                onChange={value => setZeroOffsetX(value)}
                inputAdditionalClassName={"input200"}
            />
            <InputTextProperty
                label={"y:"}
                val={fileEditorStore.zeroOffsetY}
                onChange={value => setZeroOffsetY(value)}
                inputAdditionalClassName={"input200"}
            />
        </PropsGroup>
    </>
}

export default observer(GridOffsetProperties)